import { MICROSERVICES } from '@shared/constants/microservices';

type MockPathRule = {
    path: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    header?: string;
    xAppId?: string;
};

type MockRule = {
    serviceKey: keyof typeof MICROSERVICES;
    paths: MockPathRule[];
};

export const MOCK_RULES: MockRule[] = [
    {
        serviceKey: 'impersonation',
        paths: [],
    },
    {
        serviceKey: 'example',
        paths: [
            // { path: '/user', method: 'GET', header: 'example=subscriptionType_legacy' },
            // { path: '/user', method: 'GET', header: 'example=payment_method' },
            // { path: '/user', method: 'GET', header: 'example=no_vehicle_created' },
            // { path: '/user', method: 'GET', header: 'example=subscriptionType_gold' },
            // { path: '/user', method: 'GET', header: 'example=termsAndConditionsNOTAccepted' },
            // { path: '/user', method: 'PATCH', header: 'example=subscriptionType_silver' }
        ],
    },
];

export type { MockPathRule, MockRule };
